import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgSmileyOkay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(-4 -4)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0 0h48v48H0z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 31,
				cy: 19,
				r: 3,
				fill: "#4BB678",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 19,
				r: 3,
				fill: "#4BB678",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M0 0h48v48H0z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 31,
				cy: 19,
				r: 3,
				fill: "#424D57",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 19,
				r: 3,
				fill: "#424D57",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#424D57",
				fillRule: "nonzero",
				d: "M23.98 4C12.94 4 4 12.96 4 24s8.94 20 19.98 20C35.04 44 44 35.04 44 24S35.04 4 23.98 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16zm-9-12h18v3H15v-3z"
			})
		]
	})
});
export default SvgSmileyOkay;
